import { CharComp } from '@/components/CharComp'
import '@/layouts/handicap-real-time-transaction-header.scss'
import classNames from 'classnames'
import { useI18n } from 'i18n-utils'
import { HandicapType, useDoubleContractKlineStore } from 'store'
import { HandicapBuyIcon, HandicapIcon, HandicapSellIcon } from 'ui-components'
import '../../SpotTrade/styles/handicap.scss'
import { HandicapBuy } from './HandicapBuy'
import { HandicapClosePrice } from './HandicapClosePrice'
import { HandicapSell } from './HandicapSell'

export const Handicap = defineComponent({
  setup() {
    const { t } = useI18n()

    const klineStore = useDoubleContractKlineStore()

    const unit = computed(() => {
      return klineStore.getFromSymbolName()
    })

    return () => (
      <div class={'handicap-layout'}>
        <div class="handicap-real-time-transaction-header">
          <div class="icons">
            <HandicapIcon isActive={klineStore.handicapType === HandicapType.All} onClick={() => klineStore.setHandicapType(HandicapType.All)} />
            <HandicapBuyIcon isActive={klineStore.handicapType === HandicapType.Buy} onClick={() => klineStore.setHandicapType(HandicapType.Buy)} />
            <HandicapSellIcon isActive={klineStore.handicapType === HandicapType.Sell} onClick={() => klineStore.setHandicapType(HandicapType.Sell)} />
          </div>
          <div class="header">
            <div class="header-item">
              <CharComp>
                {t('价格')}({klineStore.getToSymbolName()})
              </CharComp>
            </div>
            <div class="header-item">
              <CharComp>
                {t('数量')}({unit.value})
              </CharComp>
            </div>
            <div class="header-item">
              <CharComp>{t('成交额')}(USDT)</CharComp>
            </div>
          </div>
        </div>
        <HandicapSell
          class={classNames({
            show: [HandicapType.All, HandicapType.Sell].includes(klineStore.handicapType),
          })}
        />
        <HandicapClosePrice />
        <HandicapBuy
          class={classNames({
            show: [HandicapType.All, HandicapType.Buy].includes(klineStore.handicapType),
          })}
        />
      </div>
    )
  },
})
